<header class="header"></header>
<div class="container-gray isBackgoround">
  <main>
    <div
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      "
      class="v-application v-application--is-ltr theme--light main">
      <div
        class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--filled v-text-field--is-booted v-text-field--enclosed"
      ></div>
      <img
        class="mb-10"
        style="margin-top: 40px"
        width="170px"
        src="/assets/collabo-portal/images/icon_mail.svg"
        alt=""
      />

      <h1 style="text-align: center;" class="mb-10 h3 topic">パスワード再設定メールの送信完了</h1>

      <p class="mb-10 text-center">
        ご入力いただいた以下のアドレスへ再設定メールを送信しました。<br />
        メールボックスに届いたメールをご確認ください。
      </p>

      <div
        class="mb-10 v-card v-sheet theme--light elevation-0"
      >
        <div>
          <p class="text-bold">メールアドレス</p>
        </div>
        <div class="gray-box">
          <p>{{ email }}</p>
        </div>
        <div class="mb-3"></div>

        <div class="mb-3"></div>
        <div class="v-card__title text-caption blue-box">
          <div
            style="
              padding: 10px;
              display: flex;
              align-items: center;
              flex-direction: column;
            "
          >
            <p class="text-notes text-center mb-3">
              メールが届かない方は、<br />
              以下の「パスワード再設定メール再入力」ボタンを押下してください。
            </p>
            <button class="primary-button" (click)="passwordReset()">
              <p style="font-size: 18px;" >パスワード再設定メール再入力</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
